export default class Constants {
  static readonly UserGroups = {
    ADMIN: {
      code: 'ADMIN',
      name: 'Admin',
    },
    SITE_MANAGER: {
      code: 'SITE_MANAGER',
      name: 'Site Manager',
    },
    SITE_USER: {
      code: 'SITE_USER',
      name: 'Site User',
    },
    USER: {
      code: 'USER',
      name: 'User',
    },
  };

  static readonly Permits = {
    SYSTEM: 'SYSTEM',                      // run system api ex. batch
    MASTER: 'MASTER',                      // manage master data
    ADMIN: 'ADMIN',                        // system administrator
    CUSTOMER: 'CUSTOMER',                  // manage customers
    TFA_TRUST: 'TFA_TRUST',                // allow user to trust device for 2FA
    USER: 'USER',                          // manage users

    // exception permits for at&t temp solution (i don't like this idea but i've been forced by PI)
    NO_TFA_TRUST: 'NO_TFA_TRUST',          // group doesn't need to perform 2fa
    LONG_TTL_TOKEN: 'LONG_TTL_TOKEN',      // extended token ttl
  }

  static Sites: any = {
    INTOBEE: {
      code: 'INTOBEE',
      name: 'intobee.com'
    },
    JACCOUNTING: {
      code: 'JACCOUNTING',
      name: 'jaccounting.net'
    }
  };

  static readonly ActiveOptions = {
    ACTIVE: {
      code: 'ACTIVE',
      name: 'Active',
      boolean: true,
    },
    INACTIVE: {
      code: 'INACTIVE',
      name: 'Inactive',
      boolean: false,
    },
  };

  static Timezone: any = [
    `America/New_York`,
  ];

  static TaskType = [{ code: 'VAT', name: 'VAT' }];
}
